<div class="toaster" [ngClass]="level">
  <mat-icon class="icon" [color]="getColor()">{{ getIcon() }}</mat-icon>
  <span class="text">
    {{ message }}
  </span>
</div>
